import { takeLatest, put, select, call, cancel } from 'redux-saga/effects';
import get from 'lodash/get';

import {
  activeChannelIdSelector,
  activeContextChannelSelector,
} from '../selectors';
import chatConsts from '../constants';
import { isHealthBoardPage } from '../helpers/isHealthboardSaga';

function* conversationChangedWorker(action) {
  const isHealthBoard = yield call(isHealthBoardPage);
  if (isHealthBoard) yield cancel();

  const activeChannelID = yield select(activeChannelIdSelector);
  const activeChannel = yield select(activeContextChannelSelector);
  let channel = action.payload;

  if (
    action.payload.channelId === activeChannelID &&
    get(activeChannel, 'channelName') !== 'activities'
  ) {
    channel = { ...action.payload, unreadCount: 0 };
  }

  yield put({
    type: chatConsts.FETCH_MESSAGES,
    payload: channel,
  });
}

export default function* conversationChangedSaga() {
  yield takeLatest(
    [chatConsts.CONVERSATION_CHANGED],
    conversationChangedWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/chatConnection/sagas/conversationChanged.js